import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  Box,
  Typography,
  Container,
  Button,
} from '@mui/material';
import {
  People as AccountsIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import OrganizationsManagement from '../../components/admin/OrganizationsManagement';

const ContasPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Verificar se é WhiteLabel baseado na rota ou propriedade do usuário
  const isWhiteLabel = location.pathname.includes('/whitelabel') || user?.isWhiteLabel || user?.role === 'whitelabel';

  const handleBackClick = () => {
    const basePath = isWhiteLabel ? '/admin/whitelabel' : '/admin/super-admin';
    navigate(basePath);
  };

  // Não mostrar o header quando estamos em subrotas
  const basePath = isWhiteLabel ? '/admin/whitelabel' : '/admin/super-admin';
  const isSubRoute = location.pathname !== `${basePath}/contas` &&
    !location.pathname.endsWith(`${basePath}/contas/`);

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {!isSubRoute && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBackClick}
            sx={{ mr: 2, textTransform: 'none' }}
          >
            Voltar
          </Button>
          <AccountsIcon sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
            Contas
          </Typography>
        </Box>
      )}

      <OrganizationsManagement />
    </Container>
  );
};

export default ContasPage;
